import { createComponent, siteUrl } from '#utils/template.js';
import styles from './PocketOption.scss?inline';
import { $t } from '#utils/translation.js';

export enum Variants {
  Light = 'widget-pocket-option-view-1',
  Dark = 'widget-pocket-option-view-2',
}

export interface CreatePocketOptionProps {
  variant: Variants;
  rating: number;
  tuRef: string;
}

export function createPocketOptionComponent(props: CreatePocketOptionProps): HTMLElement {
  return createComponent(
    `<a href='${props.tuRef}' class="block" target="_blank">
      <div class="widget widget-pocket-option ${props.variant}">
        <img src="${siteUrl('/media/assets/img/Star x2.svg')}" alt="Logo">
        <span>
          <b>${props.rating}</b>
        </span>  
        <div class="widget-pocket-star-with-text">
          <img src="${siteUrl('/media/assets/img/Union.svg')}" alt="Star 2">
          <span>${$t('on')} Traders Union</span>
        </div>
      </div>
  </a>`,
    styles,
  );
}
